import {
  Directive,
  ElementRef,
  EventEmitter,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";

@Directive({
  selector: "[tailwindBreakpoint]",
  standalone: true,
})
export class TailwindBreakpointDirective implements OnInit, OnDestroy {
  /* 
  see: https://tailwindcss.com/docs/responsive-design
  Breakpoint prefix	Minimum width	CSS
  sm	40rem (640px)	@media (width >= 40rem) { ... }
  md	48rem (768px)	@media (width >= 48rem) { ... }
  lg	64rem (1024px)	@media (width >= 64rem) { ... }
  xl	80rem (1280px)	@media (width >= 80rem) { ... }
  2xl	96rem (1536px)	@media (width >= 96rem) { ... } 
  */

  @Output()
  documentResized = new EventEmitter<AppResizeEvent>();

  private readonly resizeObserver;

  private breakpointFromWidth(width: number): Breakpoint {
    if (width >= 1536) {
      return "2xl";
    } else if (width >= 1280) {
      return "xl";
    } else if (width >= 1024) {
      return "lg";
    } else if (width >= 768) {
      return "md";
    } else if (width >= 640) {
      return "sm";
    }
    return "";
  }

  constructor(private ngZone: NgZone) {
    this.resizeObserver = new ResizeObserver((entries) => {
      if (entries.length == 1) {
        this.ngZone.run(() => {
          this.documentResized.emit({
            width: entries[0].contentRect.width,
            height: entries[0].contentRect.height,
            breakpoint: this.breakpointFromWidth(entries[0].contentRect.width),
          });
        });
      }
    });
  }

  ngOnInit() {
    this.resizeObserver.observe(document.documentElement);
  }

  ngOnDestroy() {
    this.resizeObserver.disconnect();
  }
}

export type Breakpoint = "" | "sm" | "md" | "lg" | "xl" | "2xl";
export interface AppResizeEvent {
  width: number;
  height: number;
  breakpoint: Breakpoint;
}
